import React, { useEffect, useState } from "react";
import { useFetchPolicyDetails } from "../../hooks/all.hooks";
import { Link, useNavigate, useParams } from "react-router-dom";
import DetailsBackground from "../../components/NewsDetailsBg";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PolicyForms from "../CallToAction/PolicyForm";

const PolicyObservatoryDetails: React.FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const { id } = useParams<{ id: string }>();
  // const { policySlug } = useParams();

  // Convert hyphens back to spaces for display
  const policyTitle = id?.replace(/-/g, " ");

  const { data, isLoading, isError } = useFetchPolicyDetails(
    policyTitle as string
  );

  const policyDetail = data?.policy;

  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError, navigate]);

  if (isLoading) return <p>Loading...</p>;

  if (isError) {
    // Optional: You can keep a fallback UI here temporarily before redirecting
    return null;
  }

  return (
    <>
      <DetailsBackground title={policyDetail?.policyTitle || "more details"} />
      <div className="container mx-auto px-4 mb-14" id="policy-observatory">
        <div className="bg-card w-full rounded-lg shadow-lg p-4 mb-4 border-b-transparent">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="flex flex-col gap-2 mb-4 items-center border-r-2 border-primary">
              <p className="font-bold text-foreground text-sm">Policy Type</p>
              <ul className="grid grid-cols-1">
                {policyDetail?.policyType.map((policy: any, index: number) => (
                  <li className="text-card-foreground/50 text-xs" key={index}>
                    {policy?.value}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-2 mb-4 items-center border-r-2 border-primary">
              <p className="font-bold text-foreground text-sm">
                Policy Element
              </p>
              <ul className="grid grid-cols-1">
                {policyDetail?.policyElement.map(
                  (policy: any, index: number) => (
                    <li className="text-card-foreground/50 text-xs" key={index}>
                      {policy?.value}
                    </li>
                  )
                )}
              </ul>
            </div>

            <div className="flex flex-col gap-2 mb-4 items-center">
              <p className="font-bold text-foreground text-sm">
                Policy Requirements
              </p>
              <ul className="grid grid-cols-1">
                {policyDetail?.policyRequirement.map(
                  (policy: any, index: number) => (
                    <li className="text-card-foreground/50 text-xs" key={index}>
                      {policy?.value}
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
          <div className="ml-2 grid content-start lg:col-span-2">
            <p
              className="text-sm text-card-foreground news-content"
              dangerouslySetInnerHTML={{
                __html: policyDetail?.policyDescription,
              }}
            ></p>
            <div className="mt-4">
              <p>{/* apply to add policy for your country */}</p>
            </div>
          </div>

          <div className="flex  gap-2 mb-2 items-center">
            <p className="font-bold text-foreground text-sm">Policy Website:</p>
            <Link
              to={policyDetail?.policyLink}
              target="_blank"
              rel="noreferrer"
              className="text-primary text-xs"
            >
              {policyDetail?.policyLink}
            </Link>
          </div>
          {policyDetail?.policyAdoptionDate && (
            <div className="flex gap-2 mb-2 items-center">
              <p className="font-bold text-foreground text-sm">
                Policy Adoption Date:
              </p>
              <p className="text-foreground/50 text-xs">
                {new Date(
                  policyDetail?.policyAdoptionDate
                ).toLocaleDateString()}
              </p>
            </div>
          )}
          {policyDetail?.policyEffectiveDate && (
            <div className="flex gap-2 mb-2 items-center">
              <p className="font-bold text-foreground text-sm">
                Policy Effective Date:
              </p>
              <p className="text-foreground/50 text-xs">
                {new Date(
                  policyDetail?.policyEffectiveDate
                ).toLocaleDateString()}
              </p>
            </div>
          )}
          <div className="flex gap-2 mb-2 items-center">
            <p className="font-bold text-foreground text-sm">Country:</p>
            <p className="text-foreground/50 text-xs">
              {policyDetail?.country}
            </p>
          </div>
          <div className="flex gap-2 mb-2 items-center">
            <p className="font-bold text-foreground text-sm">Organization:</p>
            <p className="text-foreground/50 text-xs">
              {policyDetail?.organization}
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-8">
        <button
          onClick={toggleModal}
          className="bg-primary hover:bg-primary-600 text-primary-foreground px-4 py-2"
        >
          Click to contribute to the Policy Observatory
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full relative">
            {/* Close button */}
            <button
              onClick={toggleModal}
              type="button"
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} className="w-6 h-6" />
            </button>
            <PolicyForms onSuccess={toggleModal} />
          </div>
        </div>
      )}
    </>
  );
};

export default PolicyObservatoryDetails;
